import sheetCaracteristics from '@/sui/sc/sheetCaracteristics'
import caracteristics from '@/sui/sc/caracteristics'

import infTables from '@/sui/data/caracteristics/infections/table'
import reaInfADITables from '@/sui/data/caracteristics/reaInfADI/table'
import neoInfADITables from '@/sui/data/caracteristics/neoInfADI/table'
import diaInfADITables from '@/sui/data/caracteristics/diaInfADI/table'
import o4Tables from '@/sui/data/caracteristics/observa4/table'

function addSheet (n, s, t) {
  const obs = s === 'observa4'
  const step = obs ? 1 : 2
  return {
    name: n,
    distribution: s,
    style: s,
    doubles: false,
    observation: obs,
    surveillanceField: 'sv',
    tables: (y) => {
      if (obs && y === '2019') {
        return []
      }
      return t(true, y)
    },
    variables: (y) => {
      if (obs && y === '2019') {
        return []
      }
      return sheetCaracteristics.filterVariables[s](y)
    },

    sheetList: function (vm, y, dset) {
      const result = vm.getSheets(dset, s, step)
      return result
    },

    load: function (y, d) {
      return {
        event: 'dataset/sheets',
        request: {
          cache: true,
          name: d,
          mod: s,
          step: step
        }
      }
    },

    loadFromVersion: function (y, d, list) {
      return {
        event: 'sheet/fromVersion',
        request: {
          mod: s,
          year: parseInt(y),
          sheets: list
        }
      }
    },

    getSheetsFromDataset: function (dset) {
      if (dset.mod === this.style) {
        return dset.shev
      }
      return []
    }
  }
}

function addInfection (n, s, t, gs, p) {
  return {
    name: n,
    distribution: 'bact',
    doubles: true,
    surveillanceField: 'surv',
    prefix: p,
    type: t,
    style: s,
    observation: false,
    tables: (y) => infTables[t](y, true),
    variables: (y) => caracteristics.filterVariables(y),

    sheetList: function (vm, y, dset) {
      const i = vm.infections[y]
      if (i == null) {
        return null
      }

      return i[t]
    },

    load: function (y, d) {
      return {
        event: 'infections/all',
        request: {
          y: parseInt(y), inf: t, dset: d
        }
      }
    },

    loadFromVersion: function (y, d, list) {
      return {
        event: 'infections/fromVersion',
        request: {
          y: parseInt(y),
          inf: t,
          dset: d,
          sheets: list
        }
      }
    },

    getSheetsFromDataset: gs
  }
}

function getBactFromDataset (dset) {
  if (dset.mod === 'observa4') {
    return []
  }

  return dset.shev
}

function getPneuFromDataset (dset) {
  if (dset.mod === 'reaInfADI' ||
      (dset.mod === 'expADI' && dset.pneu != null && dset.pneu.length > 0)) {
    return dset.shev
  }

  return []
}

function buildPromises (store, target, list, surveillance) {
  const promises = []
  const loaded = {}
  for (let y in list) {
    const c = list[y]
    if (c === '') {
      continue
    }

    loaded[y] = c
    const l = target.load(y, c)
    promises.push(
      store.dispatch(l.event, l.request)
    )

    if (surveillance) {
      promises.push(
        store.dispatch('surveillances/all', y)
      )
    }
  }
  return {
    promises: promises,
    names: loaded
  }
}

function buildPromisesFromDatasets (store, target, datasets) {
  const promises = []
  const names = {}

  for (let i = 0; i !== datasets.length; ++i) {
    const data = datasets[i]
    const sheets = []

    for (let j = 0; j !== data.list.length; ++j) {
      sheets.push(...target.getSheetsFromDataset(data.list[j]))
    }

    names[data.year] = data.name
    const l = target.loadFromVersion(data.year, data.name, sheets)
    promises.push(store.dispatch(l.event, l.request))
  }

  return {
    promises,
    names
  }
}

export default {
  targets: [
    addInfection('Bactériémies', 'results', 'bact', getBactFromDataset, ''),
    addInfection('Pneumopathies', 'reaSink', 'pneu', getPneuFromDataset, 'p_'),
    addSheet('Réa Inf ADI', 'reaInfADI', reaInfADITables),
    addSheet('Dia Inf ADI', 'diaInfADI', diaInfADITables),
    addSheet('Néo Inf ADI', 'neoInfADI', neoInfADITables),
    addSheet('Observa4', 'observa4', o4Tables)
  ],

  buildPromises,
  buildPromisesFromDatasets
}
